import { render, staticRenderFns } from "./PayrollConceptEditor.vue?vue&type=template&id=46311dac&scoped=true"
import script from "./PayrollConceptEditor.vue?vue&type=script&lang=js"
export * from "./PayrollConceptEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46311dac",
  null
  
)

export default component.exports